module.exports = __webpack_public_path__ + "static/media/wd-excellence.fb3baf71.jpg";